/* Single image */
import simg1 from "../images/service-single/1.jpg";
import simg2 from "../images/service-single/stools/1.jpg";
import icon1 from "../images/service-single/beds/bed-chair.png";
import icon2 from "../images/service-single/stools/stool.png";
import icon4 from "../images/service-single/examination-lights/treatment-lights.png";
import icon5 from "../images/service-single/autoclaves/autoclave.png";
import icon6 from "../images/service-single/trolleys/cabinet.png";

const Products = [
  {
    id: 1,
    icon: icon1,
    simage: simg1,
    title: "Beds",
    slug: "beds",
    catalog: "/files/catalog/skien-product-catalog.pdf",
    shortDesc:
      "Electric treatment beds, liposuction beds, and dental chairs built for comfort, precision, and durability in professional environments.",
    colorSwatches: {
      pvcLeather: [
        { code: "270-01", hex: "#14131D" },
        { code: "270-02", hex: "#EEEEEE" },
        { code: "270-03", hex: "#F6F0D8" },
        { code: "270-04", hex: "#CBBCA7" },
        { code: "270-05", hex: "#C9B390" },
        { code: "270-06", hex: "#CBC3B6" },
        { code: "270-07", hex: "#C7C0B2" },
        { code: "270-08", hex: "#71675B" },
        { code: "270-09", hex: "#C27734" },
        { code: "270-10", hex: "#32292C" },
        { code: "270-11", hex: "#1B2129" },
        { code: "270-12", hex: "#871F28" },
        { code: "270-13", hex: "#FFE4BD" },
        { code: "270-14", hex: "#FAE2A4" },
        { code: "270-15", hex: "#B0977D" },
        { code: "270-16", hex: "#A49582" },
        { code: "270-17", hex: "#B9BAA0" },
        { code: "270-18", hex: "#ABC8B7" },
        { code: "270-19", hex: "#ACB1C1" },
        { code: "270-20", hex: "#FDCBCC" },
        { code: "270-21", hex: "#CDE1CA" },
        { code: "270-22", hex: "#6A6D76" },
        { code: "270-23", hex: "#3F3631" },
        { code: "270-24", hex: "#474948" },
        { code: "270-25", hex: "#9F876D" },
        { code: "270-26", hex: "#B7926C" },
        { code: "270-27", hex: "#684F3B" },
        { code: "270-28", hex: "#B38146" },
        { code: "270-29", hex: "#7E583B" },
        { code: "270-30", hex: "#754431" },
        { code: "270-31", hex: "#5C1F24" },
        { code: "270-32", hex: "#482622" },
        { code: "270-33", hex: "#777545" },
        { code: "270-34", hex: "#EBC63A" },
        { code: "270-35", hex: "#CE6B27" },
        { code: "270-36", hex: "#D4D5CD" },
        { code: "270-37", hex: "#9F8F85" },
        { code: "270-38", hex: "#645E5A" },
        { code: "270-39", hex: "#2A1A3C" },
        { code: "270-40", hex: "#212042" },
        { code: "270-41", hex: "#24191D" },
        { code: "270-42", hex: "#34323D" },
        { code: "270-43", hex: "#275267" },
        { code: "270-44", hex: "#2B6EA3" },
        { code: "270-45", hex: "#F76A1A" },
        { code: "270-46", hex: "#5FD296" },
      ],
      microfiberLeather: [
        { code: "270-01", hex: "#14131D" },
        { code: "270-02", hex: "#EEEEEE" },
        { code: "270-03", hex: "#F6F0D8" },
        { code: "270-04", hex: "#CBBCA7" },
        { code: "270-05", hex: "#C9B390" },
        { code: "270-06", hex: "#CBC3B6" },
        { code: "270-07", hex: "#C7C0B2" },
        { code: "270-08", hex: "#71675B" },
        { code: "270-09", hex: "#C27734" },
        { code: "270-10", hex: "#32292C" },
        { code: "270-11", hex: "#1B2129" },
        { code: "270-12", hex: "#871F28" },
        { code: "270-13", hex: "#FFE4BD" },
        { code: "270-14", hex: "#FAE2A4" },
        { code: "270-15", hex: "#B0977D" },
        { code: "270-16", hex: "#A49582" },
        { code: "270-17", hex: "#B9BAA0" },
        { code: "270-18", hex: "#ABC8B7" },
        { code: "270-19", hex: "#ACB1C1" },
        { code: "270-20", hex: "#FDCBCC" },
        { code: "270-21", hex: "#CDE1CA" },
        { code: "270-22", hex: "#6A6D76" },
        { code: "270-23", hex: "#3F3631" },
        { code: "270-24", hex: "#474948" },
        { code: "270-25", hex: "#9F876D" },
        { code: "270-26", hex: "#B7926C" },
        { code: "270-27", hex: "#684F3B" },
        { code: "270-28", hex: "#B38146" },
        { code: "270-29", hex: "#7E583B" },
        { code: "270-30", hex: "#754431" },
        { code: "270-31", hex: "#5C1F24" },
        { code: "270-32", hex: "#482622" },
        { code: "270-33", hex: "#777545" },
        { code: "270-34", hex: "#EBC63A" },
        { code: "270-35", hex: "#CE6B27" },
        { code: "270-36", hex: "#D4D5CD" },
        { code: "270-37", hex: "#9F8F85" },
        { code: "270-38", hex: "#645E5A" },
        { code: "270-39", hex: "#2A1A3C" },
        { code: "270-40", hex: "#212042" },
        { code: "270-41", hex: "#24191D" },
        { code: "270-42", hex: "#34323D" },
        { code: "270-43", hex: "#275267" },
        { code: "270-44", hex: "#2B6EA3" },
        { code: "270-45", hex: "#F76A1A" },
        { code: "270-46", hex: "#5FD296" },
      ],
      antiAlcoholLeather: [
        { code: "21-01", hex: "#F4F4F4" },
        { code: "21-02", hex: "#F3EBDE" },
        { code: "21-03", hex: "#DCDAE5" },
        { code: "21-04", hex: "#F7B6D6" },
        { code: "21-05", hex: "#C2CEE5" },
        { code: "21-06", hex: "#B9A1CB" },
        { code: "21-07", hex: "#9966A1" },
        { code: "21-08", hex: "#F27E03" },
        { code: "21-09", hex: "#E84F25" },
        { code: "21-10", hex: "#D2171D" },
        { code: "21-11", hex: "#F8DE40" },
        { code: "21-12", hex: "#D3D132" },
        { code: "21-13", hex: "#BCDEDD" },
        { code: "21-14", hex: "#A2D9F8" },
        { code: "21-15", hex: "#80CAA9" },
        { code: "21-16", hex: "#009383" },
        { code: "21-17", hex: "#9C9D95" },
        { code: "21-18", hex: "#6B625D" },
        { code: "21-19", hex: "#978065" },
        { code: "21-20", hex: "#7B6B61" },
        { code: "21-21", hex: "#149ADB" },
        { code: "21-22", hex: "#304A7D" },
        { code: "21-23", hex: "#66292E" },
        { code: "21-24", hex: "#33282C" },
        { code: "21-25", hex: "#1C1D18" },
      ],
    },
    subcategories: [
      {
        name: "Electric 3/4 Motor Beds",
        slug: "electric-motor-beds",
        items: [
          {
            code: "E22-01",
            coverImage: "/images/beds/electric-beds/E22-01/9.webp",
            images: Array.from(
              { length: 14 },
              (_, i) => `/images/beds/electric-beds/E22-01/${i + 1}.webp`
            ),
            intro:
              "A premium 3-motor treatment bed designed for precision, comfort, and effortless adjustability ideal for professional spa, wellness, and medical environments.",
            description:
              "The E22-01 Electric Motor Bed combines ergonomic engineering with refined aesthetics. Its three silent linear actuators allow independent control of height, backrest, and leg sections, enabling smooth transitions for multiple treatment positions. The high-density foam padding and antimicrobial leather upholstery ensure lasting comfort and easy maintenance. A durable stainless-steel base adds superior stability and a modern, minimalist look. The intuitive hand remote allows effortless positioning for both practitioner and client convenience.",
            features: [
              "Three silent electric motors for height, backrest, and leg adjustment",
              "High-density foam cushioning with premium antimicrobial leather upholstery",
              "Stainless-steel base with integrated LED accent lighting",
              "Detachable headrest with face hole for multipurpose use",
              "Ergonomic hand remote for smooth, precise positioning",
              "Hidden wiring and stable frame construction for safety and easy cleaning",
            ],
            industries:
              "Ideal for aesthetic clinics, medical spas, wellness centers, physiotherapy practices, and dermatology or cosmetic treatment facilities.",
          },
          {
            code: "E019-2",
            coverImage: "/images/beds/electric-beds/E019-2/4.webp",
            images: Array.from(
              { length: 9 },
              (_, i) => `/images/beds/electric-beds/E019-2/${i + 1}.webp`
            ),
            intro:
              "A stylish 4-motor electric treatment bed offering precision, comfort, and effortless multi-position control — crafted to meet the needs of modern aesthetic and medical professionals.",
            description:
              "The SKIEN E019-2 Electric 3/4 Motor Bed delivers quiet, fluid motion through its four independent actuators, allowing full control of height, backrest, leg, and tilt positions. Its premium pink antimicrobial upholstery adds a fresh, contemporary aesthetic to any clinic or spa. Padded armrests and a removable head cushion provide ergonomic support for both client and practitioner. A durable composite base with smooth hydraulic lift ensures exceptional stability and long-term reliability.",
            features: [
              "Four silent electric motors for height, backrest, leg, and tilt adjustments",
              "Ergonomic armrests and detachable head cushion with face hole",
              "Soft high-density foam with antimicrobial pink leather upholstery",
              "Foot-controlled hydraulic lift for stable vertical adjustment",
              "Smooth, quiet operation with heavy-duty base and hidden wiring",
              "Ideal for multifunctional use across medical, spa, and wellness settings",
            ],
            industries:
              "Perfect for aesthetic clinics, beauty spas, wellness studios, physiotherapy centers, and cosmetic medical environments.",
          },
          {
            code: "ADM814",
            coverImage:
              "/images/beds/electric-beds/ADM814/black-base/4.webp",
            color: "Black Base",
            images: Array.from(
              { length: 10 },
              (_, i) =>
                `/images/beds/electric-beds/ADM814/black-base/${
                  i + 1
                }.webp`
            ),
            intro:
              "A high-performance four-motor electric bed that blends luxurious comfort with durable functionality — ideal for advanced spa, medical, and aesthetic treatments.",
            description:
              "The SKIEN ADM814 Electric Motor Bed (Black Base) is engineered for precision and longevity. Featuring four whisper-quiet motors, this bed allows independent adjustment of height, backrest, leg, and tilt functions for optimal ergonomics and client comfort. Its high-density foam and premium black leather upholstery provide exceptional support, while the reinforced base ensures unmatched stability during intensive procedures. The smooth, curved design complements modern interiors, making it both a statement piece and a professional-grade essential.",
            features: [
              "Four electric motors for smooth, independent adjustment of all sections",
              "Premium black leather upholstery for durability and sophisticated aesthetics",
              "High-density foam cushioning for superior comfort and long-term use",
              "Reinforced heavy-duty base with stable, ergonomic structure",
              "Detachable headrest and adjustable armrests for versatile treatments",
              "Handheld remote control with responsive precision movement",
            ],
            industries:
              "Designed for high-end medical spas, physiotherapy clinics, beauty and wellness centers, and cosmetic dermatology practices.",
          },
          {
            code: "ADM814",
            coverImage:
              "/images/beds/electric-beds/ADM814/white-base/15.webp",
            color: "White Base",
            images: Array.from(
              { length: 23 },
              (_, i) =>
                `/images/beds/electric-beds/ADM814/white-base/${
                  i + 1
                }.webp`
            ),
            intro:
              "A premium four-motor electric bed designed to deliver silent precision, comfort, and timeless white elegance for professional aesthetic and wellness environments.",
            description:
              "The SKIEN ADM814 Electric Motor Bed (White Base) combines smooth performance with clinical sophistication. Built with four independent actuators, it provides seamless motion across all sections — ideal for facial, massage, and medical procedures. The crisp white finish and antimicrobial leather upholstery promote hygiene and modern appeal. A robust lifting system ensures safety and strength, while the remote control allows effortless position adjustments for practitioners.",
            features: [
              "Four powerful, low-noise electric motors for effortless adjustment",
              "Elegant white leather upholstery for a clean, hygienic appearance",
              "Ergonomic structure with adjustable back, leg, and tilt sections",
              "Heavy-duty base ensuring long-term performance and stability",
              "Hand control for smooth, customizable positioning",
              "Detachable head cushion and armrests for treatment flexibility",
            ],
            industries:
              "Perfect for cosmetic clinics, luxury spas, wellness facilities, and professional treatment centers.",
          },
          {
            code: "AD-24-01DX",
            coverImage:
              "/images/beds/electric-beds/AD-24-01DX/black/3.webp",
            color: "Black",
            images: Array.from(
              { length: 24 },
              (_, i) =>
                `/images/beds/electric-beds/AD-24-01DX/black/${
                  i + 1
                }.webp`
            ),
            intro:
              "A professional-grade 4-motor electric bed offering 360° rotation, precise positioning, and a durable modern design — built for clinical precision and luxury comfort.",
            description:
              "The SKIEN AD-24-01DX Electric Motor Bed delivers cutting-edge functionality for advanced treatment environments. Its four silent electric actuators provide smooth control over height, backrest, leg, and tilt adjustments, while the integrated 360-degree swivel mechanism enhances accessibility during multi-angle procedures. Constructed with a solid steel frame and premium black upholstery, the bed ensures stability, hygiene, and refined aesthetics. Integrated LED base lighting and built-in USB/power outlets make it both functional and future-ready for medical and wellness facilities.",
            features: [
              "Four silent electric motors for height, backrest, leg, and tilt adjustments",
              "360° rotation base for flexible positioning and practitioner access",
              "Heavy-duty steel structure for maximum durability and support",
              "High-density foam cushioning with premium black leather upholstery",
              "Built-in USB ports and power outlet for auxiliary device connectivity",
              "Integrated LED base lighting for aesthetic and practical illumination",
              "Ergonomic handheld controller for precise operation",
            ],
            industries:
              "Designed for use in cosmetic surgery centers, medical spas, dermatology and physiotherapy clinics, and advanced wellness facilities.",
          },
          {
            code: "AD-24-01DX",
            coverImage:
              "/images/beds/electric-beds/AD-24-01DX/white/1.webp",
            color: "White",
            images: Array.from(
              { length: 4 },
              (_, i) =>
                `/images/beds/electric-beds/AD-24-01DX/white/${
                  i + 1
                }.webp`
            ),
            intro:
              "A professional-grade 4-motor electric bed offering 360° rotation, precise positioning, and a durable modern design — built for clinical precision and luxury comfort.",
            description:
              "The SKIEN AD-24-01DX Electric Motor Bed delivers cutting-edge functionality for advanced treatment environments. Its four silent electric actuators provide smooth control over height, backrest, leg, and tilt adjustments, while the integrated 360-degree swivel mechanism enhances accessibility during multi-angle procedures. Constructed with a solid steel frame and premium black upholstery, the bed ensures stability, hygiene, and refined aesthetics. Integrated LED base lighting and built-in USB/power outlets make it both functional and future-ready for medical and wellness facilities.",
            features: [
              "Four silent electric motors for height, backrest, leg, and tilt adjustments",
              "360° rotation base for flexible positioning and practitioner access",
              "Heavy-duty steel structure for maximum durability and support",
              "High-density foam cushioning with premium black leather upholstery",
              "Built-in USB ports and power outlet for auxiliary device connectivity",
              "Integrated LED base lighting for aesthetic and practical illumination",
              "Ergonomic handheld controller for precise operation",
            ],
            industries:
              "Designed for use in cosmetic surgery centers, medical spas, dermatology and physiotherapy clinics, and advanced wellness facilities.",
          },
          {
            code: "AD-24-01DX",
            coverImage:
              "/images/beds/electric-beds/AD-24-01DX/beige/1.webp",
            color: "Cream",
            images: Array.from(
              { length: 6 },
              (_, i) =>
                `/images/beds/electric-beds/AD-24-01DX/beige/${
                  i + 1
                }.webp`
            ),
            intro:
              "A professional-grade 4-motor electric bed offering 360° rotation, precise positioning, and a durable modern design — built for clinical precision and luxury comfort.",
            description:
              "The SKIEN AD-24-01DX Electric Motor Bed delivers cutting-edge functionality for advanced treatment environments. Its four silent electric actuators provide smooth control over height, backrest, leg, and tilt adjustments, while the integrated 360-degree swivel mechanism enhances accessibility during multi-angle procedures. Constructed with a solid steel frame and premium black upholstery, the bed ensures stability, hygiene, and refined aesthetics. Integrated LED base lighting and built-in USB/power outlets make it both functional and future-ready for medical and wellness facilities.",
            features: [
              "Four silent electric motors for height, backrest, leg, and tilt adjustments",
              "360° rotation base for flexible positioning and practitioner access",
              "Heavy-duty steel structure for maximum durability and support",
              "High-density foam cushioning with premium black leather upholstery",
              "Built-in USB ports and power outlet for auxiliary device connectivity",
              "Integrated LED base lighting for aesthetic and practical illumination",
              "Ergonomic handheld controller for precise operation",
            ],
            industries:
              "Designed for use in cosmetic surgery centers, medical spas, dermatology and physiotherapy clinics, and advanced wellness facilities.",
          },
          {
            code: "AD-24-02DX",
            coverImage: "/images/beds/electric-beds/AD-24-02DX/1.webp",
            images: Array.from(
              { length: 17 },
              (_, i) =>
                `/images/beds/electric-beds/AD-24-02DX/${i + 1}.webp`
            ),
            intro:
              "A professional electric treatment chair combining smooth multi-position adjustment, segmented leg support, and integrated power access.",
            description:
              "The SKIEN AD-24-02DX Electric Treatment Chair is designed for modern clinical and wellness environments, offering smooth electric adjustment of height, backrest, seat tilt, and leg positioning through an intuitive handheld remote. Its segmented leg cushions provide enhanced lower-limb support during detailed or extended procedures, while the rigid, heavy-duty base ensures stability in all working positions. Integrated AC and USB outlets offer convenient access to power for auxiliary devices, reducing clutter and improving workflow efficiency. Finished in premium tan upholstery with high-density cushioning, the AD-24-02DX combines functional versatility, ergonomic patient comfort, and a refined contemporary aesthetic suitable for medical, cosmetic, and therapeutic applications.",
            features: [
              "Electric multi-position control for height, backrest, seat tilt, and leg section adjustments",
              "Segmented ergonomic leg cushions for enhanced lower-limb comfort and positioning",
              "Stable, heavy-duty base designed for secure support in all treatment positions",
              "Built-in AC power socket and dual USB charging ports for devices and accessories",
              "Premium tan upholstery with high-density foam, easy to wipe clean and maintain",
              "Handheld remote with intuitive icons for quick, precise adjustments",
              "Optional foot-control bar for hands-free operation during procedures",
              "Adjustable armrests and headrest to suit different patient sizes and treatment types",
              "Quiet motor operation to maintain a calm, professional environment",
            ],
            industries:
              "Ideal for cosmetic clinics, dermatology practices, medical spas, physiotherapy and rehabilitation centers, podiatry rooms, and multidisciplinary treatment facilities.",
          },
          {
            code: "08SS",
            coverImage: "/images/beds/electric-beds/08SS/black/1.webp",
            color: "Black",
            images: Array.from(
              { length: 8 },
              (_, i) =>
                `/images/beds/electric-beds/08SS/black/${i + 1}.webp`
            ),
            intro:
              "A luxurious electric treatment chair featuring a striking gold pedestal base, smooth multi-position adjustment, and premium black cushioning designed to elevate both patient comfort and clinic aesthetics.",
            description:
              "The SKIEN 08SS Electric Treatment Chair combines elegant design with practical clinical functionality, offering smooth electric adjustment of height, backrest inclination, seat angle, and legrest positioning through an easy-to-use handheld controller. Its plush black upholstery and high-density cushioning deliver excellent comfort during longer procedures, while the wide armrests and adjustable headrest provide full-body support across various treatment positions. Built on a stable gold-finished pedestal base, the 08SS brings a distinctive, high-end look to any treatment room while maintaining the reliability, strength, and silent operation expected in professional medical, cosmetic, and wellness environments.",
            features: [
              "Electric multi-position control for height, backrest, seat tilt, and legrest adjustments",
              "Premium black upholstery with durable, easy-clean finish",
              "Statement gold pedestal base for enhanced stability and a luxury aesthetic",
              "Adjustable headrest and wide armrests for patient comfort and support",
              "Quiet motor system for smooth and uninterrupted positioning",
              "Handheld controller for simple and precise operation",
              "Fully reclining capability for horizontal treatment positioning",
              "Ergonomic seat and cushioning designed for comfort during extended procedures",
            ],
            industries:
              "Perfect for cosmetic clinics, facial and skincare studios, medical spas, permanent makeup artists, tattoo studios, lash and brow specialists, and premium wellness centers seeking a comfortable, visually striking, fully electric treatment chair.",
          },
          {
            code: "08SS",
            coverImage: "/images/beds/electric-beds/08SS/white/1.webp",
            color: "White",
            images: Array.from(
              { length: 9 },
              (_, i) =>
                `/images/beds/electric-beds/08SS/white/${i + 1}.webp`
            ),
            intro:
              "A luxurious electric treatment chair featuring a striking gold pedestal base, smooth multi-position adjustment, and premium white cushioning designed to elevate both patient comfort and clinic aesthetics",
            description:
              "The SKIEN 08SS Electric Treatment Chair combines elegant design with practical clinical functionality, offering smooth electric adjustment of height, backrest inclination, seat angle, and legrest positioning through an easy-to-use handheld controller. Its plush white upholstery and high-density cushioning deliver excellent comfort during longer procedures, while the wide armrests and adjustable headrest provide full-body support across various treatment positions. Built on a stable gold-finished pedestal base, the 08SS brings a distinctive, high-end look to any treatment room while maintaining the reliability, strength, and silent operation expected in professional medical, cosmetic, and wellness environments.",
            features: [
              "Electric multi-position control for height, backrest, seat tilt, and legrest adjustments",
              "Premium white upholstery with durable, easy-clean finish",
              "Statement gold pedestal base for enhanced stability and a luxury aesthetic",
              "Adjustable headrest and wide armrests for patient comfort and support",
              "Quiet motor system for smooth and uninterrupted positioning",
              "Handheld controller for simple and precise operation",
              "Fully reclining capability for horizontal treatment positioning",
              "Ergonomic seat and cushioning designed for comfort during extended procedures",
            ],
            industries:
              "Perfect for cosmetic clinics, facial and skincare studios, medical spas, permanent makeup artists, tattoo studios, lash and brow specialists, and premium wellness centers seeking a comfortable, visually striking, fully electric treatment chair.",
          },
          {
            code: "811-3",
            coverImage: "/images/beds/electric-beds/811-3/1.webp",
            images: Array.from(
              { length: 7 },
              (_, i) => `/images/beds/electric-beds/811-3/${i + 1}.webp`
            ),
            intro:
              "A fully electric multi-function treatment chair offering smooth positioning control, premium white upholstery, and full-body support for modern clinical and aesthetic environments.",
            description:
              "The SKIEN 811-3 Electric Treatment Chair delivers reliable performance and exceptional comfort through its fully adjustable electric system, allowing effortless control of height, backrest angle, seat tilt, and legrest positioning using an intuitive handheld remote. The contoured cushioning, adjustable headrest, and wide padded armrests ensure optimal patient support in both seated and fully reclined treatment positions. Its stable, curved base provides excellent structural balance, while the crisp white upholstery adds a clean, professional aesthetic ideal for beauty, medical, and wellness facilities.",
            features: [
              "Four-way electric adjustment for height, backrest, seat tilt, and legrest",
              "Premium white upholstery with high-density cushioning",
              "Adjustable headrest and padded armrests for enhanced comfort",
              "Segmented leg cushions for stable lower-limb support",
              "Smooth, silent motor operation for a calm treatment environment",
              "Handheld controller for effortless positioning control",
              "Fully reclining capability for horizontal procedures",
              "Stable curved base designed for strength and balance",
            ],
            industries:
              "Perfect for facial aesthetics, cosmetic clinics, medical spas, dermatology rooms, lash and brow artists, PMU studios, and general wellness treatment facilities.",
          },
          {
            code: "AD-MM02",
            coverImage: "/images/beds/electric-beds/AD-MM02/1.webp",
            images: Array.from(
              { length: 2 },
              (_, i) => `/images/beds/electric-beds/AD-MM02/${i + 1}.webp`
            ),
            intro:
              "A plush, full-body adjustable treatment bed featuring premium pink upholstery and smooth sectional movement — designed for luxurious comfort in beauty and wellness environments.",
            description:
              "The SKIEN AD-MM02 Treatment Bed offers a seamless blend of comfort and style, featuring soft channel-stitched cushioning that supports the body from head to toe. Its adjustable backrest and leg section allow smooth transitions between flat, reclined, and seated positions, making it ideal for a wide range of treatments. The matching pink pedestal base provides excellent stability while maintaining a clean, modern aesthetic. With its inviting upholstery, ergonomic shape, and versatile adjustability, the AD-MM02 is a statement piece for spas, facial studios, and wellness centers seeking a premium client experience.",
            features: [
              "Adjustable backrest and leg section for versatile treatment positioning",
              "Plush full-body cushioning with channel-stitched design",
              "Premium soft pink upholstery for a warm, luxurious aesthetic",
              "Stable pedestal base in a matching color for a cohesive look",
              "Ergonomic contouring for enhanced client comfort during long sessions",
              "Removable headrest pillow for added neck support",
              "Smooth, silent adjustment mechanism",
              "Easy-clean, durable upholstery suitable for professional environments",
            ],
            industries:
              "Ideal for spas, beauty studios, facial treatment rooms, massage therapy spaces, wellness centers, and premium cosmetic environments.",
          },
          {
            code: "ADM816",
            coverImage: "/images/beds/electric-beds/ADM816/1.webp",
            images: Array.from(
              { length: 8 },
              (_, i) => `/images/beds/electric-beds/ADM816/${i + 1}.webp`
            ),
            intro:
              "A refined, fully electric treatment bed offering multi-section adjustment, premium cushioning, and elegant clinical aesthetics — ideal for high-end medical, beauty, and wellness environments.",
            description:
              "The SKIEN ADM816 Electric Treatment Bed delivers exceptional versatility and comfort through its fully automated height, backrest, mid-section, and leg adjustments controlled by a clear and intuitive handheld remote. Its plush light-cream upholstery, ergonomic contouring, and integrated face-hole design provide superior support in both flat and seated treatment positions. A removable cushion and additional support pad allow customizable comfort for various procedures, while the stable curved pedestal base ensures structural balance and smooth operation. Combining precision functionality with a premium, modern appearance, the ADM816 is an ideal centerpiece for advanced treatment rooms.",
            features: [
              "Fully electric adjustment for height, backrest, mid-section, and legrest",
              "Premium light-cream upholstery with thick, supportive cushioning",
              "Integrated face hole with removable cushion for prone treatments",
              "Additional support cushion for customizable positioning",
              "Stable, heavy-duty pedestal base with curved ergonomic design",
              "Handheld remote with reset and lighting control options",
              "Smooth and quiet motor system for seamless positioning",
              "Multi-position capability suitable for flat, reclined, or semi-seated treatments",
              "Easy-clean upholstery suited for professional clinical use",
            ],
            industries:
              "Ideal for medical spas, facial clinics, physiotherapy rooms, cosmetic and dermatology practices, massage studios, and high-end wellness facilities.",
          },
          {
            code: "ADM817",
            coverImage: "/images/beds/electric-beds/ADM817/1.webp",
            images: Array.from(
              { length: 16 },
              (_, i) => `/images/beds/electric-beds/ADM817/${i + 1}.webp`
            ),
            intro:
              "A fully electric, multi-position treatment chair featuring premium cushioning, adjustable support elements, and a stable modern base — engineered for clinical precision and client comfort.",
            description:
              "The SKIEN ADM817 Electric Treatment Chair offers smooth, fully automated adjustment of height, backrest, seat angle, and legrest through an intuitive handheld controller. Its dark-grey premium upholstery, paired with a durable white shell backing, delivers both comfort and a clean professional aesthetic. The chair includes a height-adjustable headrest, integrated face-hole for prone treatments, flip-back armrests for easier client access, and an extendable footrest section for full-body support. Built on a curved, heavy-duty pedestal base, the ADM817 maintains exceptional stability while transitioning between seated, reclined, and fully flat positions, making it ideal for advanced medical, cosmetic, and wellness treatments.",
            features: [
              "Electric height, backrest, seat tilt, and legrest adjustment",
              "Premium dark-grey cushioning with ergonomic contouring",
              "Adjustable headrest with extension rods",
              "Integrated face-hole for prone treatments",
              "Flip-back padded armrests for improved accessibility",
              "Extendable footrest section for customized leg support",
              "Stable curved pedestal base for reliable structural balance",
              "Smooth and quiet motor system",
              "Handheld remote for precise and easy control",
              "Durable white shell backing for added strength and hygiene",
            ],
            industries:
              "Ideal for dermatology rooms, cosmetic clinics, medical spas, physiotherapy spaces, facial and skincare studios, PMU and tattoo studios, and premium wellness treatment environments.",
          },
          {
            code: "E02-1",
            coverImage: "/images/beds/electric-beds/E02-1/1.webp",
            images: Array.from(
              { length: 11 },
              (_, i) => `/images/beds/electric-beds/E02-1/${i + 1}.webp`
            ),
            intro:
              "A seamless, fully electric treatment chair offering effortless adjustment, plush cushioning, and a clean clinical aesthetic — ideal for multi-disciplinary medical, beauty, and wellness treatments.",
            description:
              "The SKIEN E02-1 Electric Treatment Chair combines quiet motorised performance with soft, ergonomic cushioning to deliver outstanding comfort in every treatment position. With dedicated controls for height, backrest, and legrest adjustment, practitioners can transition quickly between upright, semi-reclined, and fully flat configurations. The chair features a supportive headrest with a removable pillow and integrated face-hole, allowing versatility for facial, massage, and forward-lying procedures. Its smooth cream upholstery, durable stitching, and minimalistic design create a professional and approachable treatment environment. Built on a wide, stable pedestal base and equipped with an intuitive hand remote, the E02-1 offers reliable functionality and modern clinical styling suitable for daily professional use.",
            features: [
              "Electric control of height, backrest, and legrest adjustments",
              "Soft cream upholstery with thick, supportive cushioning",
              "Removable head pillow with integrated face-hole option",
              "Ergonomic armrests designed for client comfort",
              "Quiet and smooth motor transitions for uninterrupted treatments",
              "Wide pedestal base ensuring structural stability",
              "Intuitive handheld remote with dedicated position controls",
              "Multi-section bed layout accommodating a variety of treatment angles",
              "Easy-clean surface suitable for medical and aesthetic environments",
              "Ideal for lying, seated, and semi-reclined procedures",
            ],
            industries:
              "Perfect for facial clinics, medical aesthetic rooms, dermatology practices, PMU and brow studios, spa and wellness centers, chiropractic and physiotherapy spaces, and general treatment rooms.",
          },
          {
            code: "E03",
            coverImage: "/images/beds/electric-beds/E03/1.webp",
            images: Array.from(
              { length: 11 },
              (_, i) => `/images/beds/electric-beds/E03/${i + 1}.webp`
            ),
            intro:
              "A fully electric, multi-functional treatment chair offering smooth adjustment, premium cushioning, and exceptional client comfort — ideal for modern medical, aesthetic, and wellness spaces.",
            description:
              "The SKIEN E03 Electric Treatment Chair provides complete versatility with automated height, backrest, seat tilt, and legrest adjustment, all controlled through an intuitive handheld remote. Its soft cream upholstery, ergonomic padding, and multi-section cushions ensure a comfortable experience in both seated and lying positions. The chair includes a removable headrest with an integrated face-hole option, flip-back armrests for improved patient access, and a wide, stable pedestal base designed for dependable support during treatments. With easy-clean upholstery and smooth, quiet motor operation, the E03 delivers both professional functionality and a clean, contemporary aesthetic suitable for a variety of treatment environments.",
            features: [
              "Electric adjustment for height, backrest, seat tilt, and legrest",
              "Premium cream upholstery with soft, ergonomic cushioning",
              "Removable headrest with integrated face-hole design",
              "Flip-back padded armrests for improved accessibility",
              "Multi-section cushions for flexible positioning",
              "Stable curved pedestal base for enhanced structural support",
              "Smooth and quiet motor system for seamless transitions",
              "Zippered upholstery for easy cleaning and replacement",
              "Handheld remote with dedicated positioning controls",
              "Suitable for seated, reclined, and fully flat treatments",
            ],
            industries:
              "Perfect for facial studios, cosmetic clinics, dermatology rooms, medical spas, physiotherapy centers, PMU and tattoo studios, and luxury wellness environments.",
          },
          {
            code: "E05",
            coverImage: "/images/beds/electric-beds/E05/black/1.webp",
            color: "Black",
            images: Array.from(
              { length: 12 },
              (_, i) =>
                `/images/beds/electric-beds/E05/black/${i + 1}.webp`
            ),
            intro:
              "A luxurious, fully electric treatment chair combining sleek aesthetics with professional-grade functionality — designed for premium medical, aesthetic, and wellness environments that value both style and performance.",
            description:
              "The SKIEN E05 Electric Treatment Chair delivers refined comfort and high-end functionality with its smooth motorised adjustment system and striking black upholstery complemented by elegant wooden armrests. Offering full control of height, backrest, seat tilt, and legrest positions, the E05 transitions effortlessly between upright, semi-reclined, and fully flat configurations. Its ergonomic multi-layer cushioning provides exceptional client comfort, while the contoured headrest with a face-hole option supports massage and forward-lying treatments. The wide pedestal base ensures superior stability, and the easy-clean upholstery maintains a polished, professional look. Equipped with a simple handheld remote and built with quiet, reliable motors, the E05 is an ideal centrepiece for any modern practice seeking sophistication without compromising functionality.",
            features: [
              "Four-motor electric system for height, backrest, legrest, and seat tilt control",
              "Premium black upholstery designed for comfort, durability, and easy cleaning",
              "Elegant wooden armrests providing a refined aesthetic",
              "Adjustable headrest with integrated face-hole for massage positioning",
              "Wide and solid pedestal base for maximum stability during procedures",
              "Ergonomic cushioning offering full-body support in all positions",
              "Smooth, quiet motor performance for seamless treatment transitions",
              "Handheld remote with dedicated buttons for quick operation",
              "Versatile lying, seated, and semi-reclined configurations",
              "Ideal for treatments requiring long-duration comfort and flexible access",
            ],
            industries:
              "Perfect for luxury spas, aesthetic clinics, cosmetic procedure rooms, dermatology practices, PMU and tattoo studios, physiotherapy spaces, and wellness centers seeking a sophisticated treatment chair.",
          },
          {
            code: "E05",
            coverImage: "/images/beds/electric-beds/E05/pink/1.webp",
            color: "Pink",
            images: Array.from(
              { length: 9 },
              (_, i) =>
                `/images/beds/electric-beds/E05/pink/${i + 1}.webp`
            ),
            intro:
              "A luxurious, fully electric treatment chair combining sleek aesthetics with professional-grade functionality — designed for premium medical, aesthetic, and wellness environments that value both style and performance.",
            description:
              "The SKIEN E05 Electric Treatment Chair delivers refined comfort and high-end functionality with its smooth motorised adjustment system and striking black upholstery complemented by elegant wooden armrests. Offering full control of height, backrest, seat tilt, and legrest positions, the E05 transitions effortlessly between upright, semi-reclined, and fully flat configurations. Its ergonomic multi-layer cushioning provides exceptional client comfort, while the contoured headrest with a face-hole option supports massage and forward-lying treatments. The wide pedestal base ensures superior stability, and the easy-clean upholstery maintains a polished, professional look. Equipped with a simple handheld remote and built with quiet, reliable motors, the E05 is an ideal centrepiece for any modern practice seeking sophistication without compromising functionality.",
            features: [
              "Four-motor electric system for height, backrest, legrest, and seat tilt control",
              "Premium black upholstery designed for comfort, durability, and easy cleaning",
              "Elegant wooden armrests providing a refined aesthetic",
              "Adjustable headrest with integrated face-hole for massage positioning",
              "Wide and solid pedestal base for maximum stability during procedures",
              "Ergonomic cushioning offering full-body support in all positions",
              "Smooth, quiet motor performance for seamless treatment transitions",
              "Handheld remote with dedicated buttons for quick operation",
              "Versatile lying, seated, and semi-reclined configurations",
              "Ideal for treatments requiring long-duration comfort and flexible access",
            ],
            industries:
              "Perfect for luxury spas, aesthetic clinics, cosmetic procedure rooms, dermatology practices, PMU and tattoo studios, physiotherapy spaces, and wellness centers seeking a sophisticated treatment chair.",
          },
          {
            code: "E016",
            coverImage: "/images/beds/electric-beds/E016/1.webp",
            images: Array.from(
              { length: 11 },
              (_, i) => `/images/beds/electric-beds/E016/${i + 1}.webp`
            ),
            intro:
              "A premium 4-motor electric treatment chair engineered for precision, comfort, and full-body support — ideal for high-performance medical, aesthetic, and therapeutic environments.",
            description:
              "The SKIEN E016 Electric Treatment Chair delivers advanced versatility with smooth motorised control of height, backrest, seat tilt, and legrest positions. Designed for multi-disciplinary use, it allows effortless transitions between flat, seated, surgical, and semi-reclined postures. The chair features a rotating base for enhanced practitioner access, flexible armrests that flip back or adjust as needed, and a contoured upholstery design that supports the body in every angle. Its quiet motor system ensures disruption-free treatments, while the durable, easy-clean cushioning maintains a professional aesthetic in any clinical or wellness space. With intuitive hand-remote operation and reinforced structural stability, the E016 is built to meet the demands of modern treatment rooms.",
            features: [
              "Four-motor system controlling height, backrest, seat tilt, and legrest",
              "Rotating base for improved accessibility around the client",
              "Flexible armrests that flip back or adjust for different treatment setups",
              "Ergonomic cushioned upholstery for long-duration comfort",
              "Multi-angle positioning ideal for medical, aesthetic, and therapeutic procedures",
              "Smooth, quiet motor operation for seamless adjustments",
              "Easy-clean, high-density padding with durable stitching",
              "Sturdy wide base for reinforced stability during procedures",
              "Handheld remote with dedicated adjustment controls",
              "Optimised for both fully flat and upright seated configurations",
            ],
            industries:
              "Ideal for aesthetic clinics, dermatology practices, medical rooms, physiotherapy environments, PMU and tattoo studios, podiatry treatments, and luxury wellness centers.",
          },
          {
            code: "E016 FOOT CONTROL",
            coverImage:
              "/images/beds/electric-beds/E016-FOOT-CONTROL/1.webp",
            images: Array.from(
              { length: 7 },
              (_, i) =>
                `/images/beds/electric-beds/E016-FOOT-CONTROL/${
                  i + 1
                }.webp`
            ),
            intro:
              "A premium, multi-functional electric treatment chair designed for effortless positioning, hands-free adjustments, and exceptional client comfort.",
            description:
              "The SKIEN E016 Foot Control Electric Bed is an advanced professional chair engineered for clinics, salons, medical aesthetics, podiatry, and wellness environments. Featuring a fully electric system with integrated foot controls, it allows practitioners to adjust height, backrest, tilt, and leg sections without interrupting treatment. The ergonomic cushioning, contoured headrest with a face hole, and sliding armrests ensure maximum comfort for clients in both seated and fully reclined positions. Built on a reinforced base with smooth, synchronized movements, the E016 provides stability, durability, and quiet operation. Its premium upholstery, modular leg sections, and intuitive foot-pedal command panel make it ideal for high-precision work and long treatment sessions.",
            features: [
              "Full electric adjustment for height, backrest, tilt, and leg sections",
              "Hands-free foot-pedal control panel for seamless workflow",
              "Ergonomic cushioning with high-density padding",
              "Adjustable headrest with removable face hole",
              "Multi-section leg support for podiatry and aesthetic procedures",
              "Sliding/rotating armrests for easy client access",
              "Heavy-duty base offering stability and quiet movement",
              "Sturdy wide base for reinforced stability during procedures",
              "Handheld remote with dedicated adjustment controls",
              "Premium leather upholstery, easy to clean and durable",
            ],
            industries:
              "Ideal for medical aesthetics, podiatry clinics, dermatology rooms, facial treatment studios, beauty salons, spa therapy spaces, and multidisciplinary wellness practices.",
          },
          {
            code: "E22-02",
            coverImage: "/images/beds/electric-beds/E22-02/1.webp",
            images: Array.from(
              { length: 12 },
              (_, i) => `/images/beds/electric-beds/E22-02/${i + 1}.webp`
            ),
            intro:
              "A premium multi-functional electric treatment chair featuring a sleek stitched-panel design, offering comfort, precision, and modern aesthetics.",

            description:
              "The SKIEN E22-02 Electric Bed is a versatile, high-performance treatment chair designed for clinics and beauty spaces that demand both functionality and style. Its signature stitched-panel upholstery adds a refined, contemporary look while enhancing client comfort through supportive cushioning. Equipped with multiple electric motors, the E22-02 allows smooth adjustments of height, backrest, leg rest, and tilt, ensuring ideal positioning for facial, aesthetic, and medical treatments. The adjustable headrest with a removable face hole, rotating armrests, and extendable leg section provide flexibility for a wide range of procedures. With its stable base, intuitive hand control, and high-end design, the E22-02 elevates both workflow and presentation in any treatment room.",

            features: [
              "Stylish stitched-panel cushioning for enhanced comfort and modern aesthetics",
              "Multiple electric motors for smooth height, backrest, leg, and tilt adjustments",
              "Adjustable headrest with removable face hole for prone positioning",
              "Rotating and removable armrests for greater access during treatments",
              "Extendable leg section to accommodate clients of different heights",
              "Stable heavy-duty base for maximum safety and support",
              "Handheld controller for quick and precise positioning",
              "Durable, easy-clean upholstery suitable for clinical and beauty environments",
            ],

            industries:
              "Ideal for aesthetic clinics, dermatology practices, facial treatment rooms, beauty salons, medspas, and wellness centers.",
          },
          // {
          //   code: "E22-03",
          //   coverImage: "/images/beds/electric-beds/E22-03/1.webp",
          //   images: Array.from(
          //     { length: 12 },
          //     (_, i) => `/images/beds/electric-beds/E22-03/${i + 1}.webp`
          //   ),
          //   intro:
          //     "A premium electric treatment bed featuring sculpted ergonomic cushioning and smooth multi-position adjustment for advanced comfort and versatility.",

          //   description:
          //     "The SKIEN E22-03 Electric Bed is a modern, medical-grade treatment chair designed with contoured, sculpted cushioning that supports the body naturally during long procedures. Its seamless electric adjustment system allows effortless control of height, backrest, and legrest positions, ensuring both practitioner efficiency and client relaxation. The chair includes plush, molded padding with soft curves that cradle the legs and back, a removable headrest pillow with a face hole, and supportive armrests for added comfort during extended sessions. Built on a sturdy base with quiet motors, the E22-03 delivers smooth, stable positioning ideal for clinical precision and beauty applications. With its clean white aesthetic, ergonomic detailing, and fully adjustable structure, this electric bed enhances both workflow and client experience.",

          //   features: [
          //     "Sculpted ergonomic cushioning that contours to the body",
          //     "Electric height, backrest, and legrest adjustment",
          //     "Smooth, quiet motor performance for stable positioning",
          //     "Removable headrest pillow with integrated face hole",
          //     "Comfortable armrests that support various treatment positions",
          //     "Thick, molded padding for long-session comfort",
          //     "Durable, easy-to-clean upholstery",
          //     "Wide and stable base for maximum safety",
          //     "Ideal reclining range for facial, medical, and aesthetic procedures",
          //   ],

          //   industries:
          //     "Suitable for aesthetic clinics, dermatology practices, medical treatment rooms, wellness centers, facial studios, cosmetic procedure rooms, and professional beauty environments.",
          // },
        ],
      },
      {
        name: "Liposuction Beds",
        slug: "liposuction-beds",
        items: [
          {
            code: "BTB-02B",
            coverImage: "/images/beds/liposuction-beds/BTB-02/8.webp",
            images: Array.from(
              { length: 17 },
              (_, i) =>
                `/images/beds/liposuction-beds/BTB-02/${i + 1}.webp`
            ),
            intro:
              "A state-of-the-art electric surgical bed built for precision, stability, and patient comfort — engineered specifically for liposuction and other high-precision medical procedures.",
            description:
              "The SKIEN BTB-02B Liposuction Bed represents the next generation of procedural comfort and control. Equipped with four synchronized electric actuators, it allows seamless adjustment of height, backrest, leg, and tilt angles for optimal operating conditions. The advanced foot-pedal system and handheld remote provide dual control flexibility for practitioners, ensuring uninterrupted workflow. Its high-density foam and antimicrobial beige leather upholstery deliver both luxury and hygiene, while the heavy-duty base integrates 360-degree rotation, USB ports, and a power outlet for surgical device connectivity.",
            features: [
              "Four electric motors with precision height, backrest, leg, and tilt control",
              "360° rotation for multi-angle accessibility during procedures",
              "Dual operation system with foot control and handheld remote",
              "High-density foam with antimicrobial beige leather upholstery",
              "Integrated USB and power socket for operating instruments",
              "Ergonomic structure for surgeon comfort and patient safety",
              "Detachable head cushion and armrests for multipurpose use",
            ],
            industries:
              "Purpose-built for cosmetic surgery, liposuction, dermatology, and aesthetic medical centers requiring precision and ergonomic functionality.",
          },
        ],
      },
      {
        name: "Manual Beds",
        slug: "manual-beds",
        items: [
          {
            code: "MBT002B",
            coverImage: "/images/beds/manual-beds/MBT002B/1.webp",
            images: Array.from(
              { length: 11 },
              (_, i) => `/images/beds/manual-beds/MBT002B/${i + 1}.webp`
            ),
            intro:
              "A durable, manually adjustable treatment bed with premium cushioning and a clean, modern design — ideal for beauty, massage, and wellness environments.",
            description:
              "The SKIEN MBT002B Manual Treatment Bed offers a simple yet highly functional design, featuring a manually adjustable backrest and a sturdy white base for dependable support. Its soft blue-grey upholstery and high-density cushioning provide excellent comfort during treatments, while the included headrest cushion enhances neck support in both flat and inclined positions. Built for everyday professional use, the MBT002B combines practicality, comfort, and a sleek aesthetic suitable for spas, massage rooms, facial studios, and general wellness facilities.",
            features: [
              "Manually adjustable backrest for flexible positioning",
              "Premium blue-grey upholstery with soft, high-density foam",
              "Sturdy white base designed for long-term durability",
              "Removable headrest cushion for added comfort",
              "Smooth, easy-to-clean upholstery surface",
              "Supportive full-length bed surface for multiple treatment types",
              "Simple, reliable, and low-maintenance construction",
              "Ideal for flat or inclined treatment positions",
            ],
            industries:
              "Perfect for massage studios, beauty salons, spas, facial treatment rooms, physiotherapy centers, and general wellness environments.",
          },
          {
            code: "LASH-01",
            coverImage: "/images/beds/manual-beds/LASH-01/1.webp",
            images: Array.from(
              { length: 4 },
              (_, i) => `/images/beds/manual-beds/LASH-01/${i + 1}.webp`
            ),
            intro:
              "A stylish, curved lash bed designed for comfort and aesthetics, offering premium support for lash and beauty treatments.",

            description:
              "The SKIEN LASH-01 Manual Bed is a luxurious, ergonomically curved treatment bed crafted specifically for lash artists, brow technicians, and beauty professionals who value comfort and visual appeal. Its plush tufted cushioning provides superior client support, while the elegant gold cross-base frame adds a high-end, modern touch to any studio. The bed includes a matching adjustable headrest pillow and a soft lumbar cushion to support long appointment sessions. With its durable upholstery, stable structure, and eye-catching design, the LASH-01 brings both beauty and comfort into treatment spaces.",

            features: [
              "Curved ergonomic design for enhanced client comfort",
              "Tufted, high-density cushioning for premium support",
              "Includes adjustable headrest pillow and matching lumbar cushion",
              "Elegant gold metal base with a modern cross-frame structure",
              "Durable, easy-to-clean upholstery",
              "Perfect height and shape for lash, brow, and facial treatments",
              "Stable construction with secure body support",
              "Aesthetic design ideal for modern studios and beauty rooms",
            ],

            industries:
              "Suitable for lash studios, brow artists, beauty salons, aesthetic rooms, makeup rooms, and boutique wellness spaces.",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    icon: icon2,
    simage: simg2,
    title: "Stools",
    slug: "stools",
    catalog: "/files/catalog/skien-product-catalog.pdf",
    shortDesc:
      "Dental stools and ergonomic saddle chairs that promote correct posture and ease of movement during treatments.",
    colorSwatches: {
      pvcLeather: [
        { code: "270-01", hex: "#14131D" },
        { code: "270-02", hex: "#EEEEEE" },
        { code: "270-03", hex: "#F6F0D8" },
        { code: "270-04", hex: "#CBBCA7" },
        { code: "270-05", hex: "#C9B390" },
        { code: "270-06", hex: "#CBC3B6" },
        { code: "270-07", hex: "#C7C0B2" },
        { code: "270-08", hex: "#71675B" },
        { code: "270-09", hex: "#C27734" },
        { code: "270-10", hex: "#32292C" },
        { code: "270-11", hex: "#1B2129" },
        { code: "270-12", hex: "#871F28" },
        { code: "270-13", hex: "#FFE4BD" },
        { code: "270-14", hex: "#FAE2A4" },
        { code: "270-15", hex: "#B0977D" },
        { code: "270-16", hex: "#A49582" },
        { code: "270-17", hex: "#B9BAA0" },
        { code: "270-18", hex: "#ABC8B7" },
        { code: "270-19", hex: "#ACB1C1" },
        { code: "270-20", hex: "#FDCBCC" },
        { code: "270-21", hex: "#CDE1CA" },
        { code: "270-22", hex: "#6A6D76" },
        { code: "270-23", hex: "#3F3631" },
        { code: "270-24", hex: "#474948" },
        { code: "270-25", hex: "#9F876D" },
        { code: "270-26", hex: "#B7926C" },
        { code: "270-27", hex: "#684F3B" },
        { code: "270-28", hex: "#B38146" },
        { code: "270-29", hex: "#7E583B" },
        { code: "270-30", hex: "#754431" },
        { code: "270-31", hex: "#5C1F24" },
        { code: "270-32", hex: "#482622" },
        { code: "270-33", hex: "#777545" },
        { code: "270-34", hex: "#EBC63A" },
        { code: "270-35", hex: "#CE6B27" },
        { code: "270-36", hex: "#D4D5CD" },
        { code: "270-37", hex: "#9F8F85" },
        { code: "270-38", hex: "#645E5A" },
        { code: "270-39", hex: "#2A1A3C" },
        { code: "270-40", hex: "#212042" },
        { code: "270-41", hex: "#24191D" },
        { code: "270-42", hex: "#34323D" },
        { code: "270-43", hex: "#275267" },
        { code: "270-44", hex: "#2B6EA3" },
        { code: "270-45", hex: "#F76A1A" },
        { code: "270-46", hex: "#5FD296" },
      ],
      microfiberLeather: [
        { code: "270-01", hex: "#14131D" },
        { code: "270-02", hex: "#EEEEEE" },
        { code: "270-03", hex: "#F6F0D8" },
        { code: "270-04", hex: "#CBBCA7" },
        { code: "270-05", hex: "#C9B390" },
        { code: "270-06", hex: "#CBC3B6" },
        { code: "270-07", hex: "#C7C0B2" },
        { code: "270-08", hex: "#71675B" },
        { code: "270-09", hex: "#C27734" },
        { code: "270-10", hex: "#32292C" },
        { code: "270-11", hex: "#1B2129" },
        { code: "270-12", hex: "#871F28" },
        { code: "270-13", hex: "#FFE4BD" },
        { code: "270-14", hex: "#FAE2A4" },
        { code: "270-15", hex: "#B0977D" },
        { code: "270-16", hex: "#A49582" },
        { code: "270-17", hex: "#B9BAA0" },
        { code: "270-18", hex: "#ABC8B7" },
        { code: "270-19", hex: "#ACB1C1" },
        { code: "270-20", hex: "#FDCBCC" },
        { code: "270-21", hex: "#CDE1CA" },
        { code: "270-22", hex: "#6A6D76" },
        { code: "270-23", hex: "#3F3631" },
        { code: "270-24", hex: "#474948" },
        { code: "270-25", hex: "#9F876D" },
        { code: "270-26", hex: "#B7926C" },
        { code: "270-27", hex: "#684F3B" },
        { code: "270-28", hex: "#B38146" },
        { code: "270-29", hex: "#7E583B" },
        { code: "270-30", hex: "#754431" },
        { code: "270-31", hex: "#5C1F24" },
        { code: "270-32", hex: "#482622" },
        { code: "270-33", hex: "#777545" },
        { code: "270-34", hex: "#EBC63A" },
        { code: "270-35", hex: "#CE6B27" },
        { code: "270-36", hex: "#D4D5CD" },
        { code: "270-37", hex: "#9F8F85" },
        { code: "270-38", hex: "#645E5A" },
        { code: "270-39", hex: "#2A1A3C" },
        { code: "270-40", hex: "#212042" },
        { code: "270-41", hex: "#24191D" },
        { code: "270-42", hex: "#34323D" },
        { code: "270-43", hex: "#275267" },
        { code: "270-44", hex: "#2B6EA3" },
        { code: "270-45", hex: "#F76A1A" },
        { code: "270-46", hex: "#5FD296" },
      ],
    },
    subcategories: [
      {
        name: "Dental Stools",
        slug: "dental-stools",
        items: [
          {
            code: "AD-500N",
            coverImage: "/images/stools/dental-stools/AD-500N/2.webp",
            images: Array.from(
              { length: 12 },
              (_, i) =>
                `/images/stools/dental-stools/AD-500N/${i + 1}.webp`
            ),
            intro:
              "An ergonomic dental stool designed for precision, mobility, and practitioner comfort — crafted to provide optimal posture support in professional clinical settings.",
            description:
              "The SKIEN AD-500N Dental Stool delivers unmatched ergonomic balance for dentists, hygienists, and medical practitioners. Its contoured seat and adjustable backrest promote healthy posture during long procedures, while the smooth-rolling castor system ensures effortless mobility around the treatment area. The stool features a gas-lift height adjustment mechanism and 360-degree swivel for dynamic flexibility. Built with a reinforced chrome base and premium leather upholstery, the AD-500N is both durable and stylish, offering a clean, professional appearance suitable for any clinical or aesthetic environment.",
            features: [
              "Ergonomic round seat design for superior posture and pressure relief",
              "Adjustable backrest with multi-angle support for lumbar comfort",
              "Gas-lift height adjustment for smooth, precise positioning",
              "360° swivel with silent, medical-grade caster wheels for easy movement",
              "Premium antimicrobial leather upholstery with easy-clean finish",
              "Reinforced chrome base for long-term durability and stability",
              "Foot ring for additional comfort and leg support during procedures",
            ],
            industries:
              "Ideal for dental clinics, aesthetic centers, dermatology rooms, and medical or wellness facilities requiring ergonomic practitioner seating.",
          },
          {
            code: "AD-600M",
            coverImage: "/images/stools/dental-stools/AD-600M/2.webp",
            images: Array.from(
              { length: 9 },
              (_, i) =>
                `/images/stools/dental-stools/AD-600M/${i + 1}.webp`
            ),
            intro:
              "A premium ergonomic dental stool engineered to deliver comfort, balance, and mobility for dentists and medical professionals during extended procedures.",
            description:
              "The SKIEN AD-600M Dental Stool provides full ergonomic support through its contoured seat and adjustable backrest design. Its multi-angle armrest ensures steady hand positioning during precision work, while the gas-lift system allows effortless height adjustment for seated stability. The stool’s chrome base offers 360° swivel functionality and smooth caster wheels for silent, fluid movement around the operating space. With high-density foam cushioning and antimicrobial blue leather upholstery, the AD-600M ensures lasting comfort and hygiene. Its modern structure supports professional posture, minimizing fatigue and enhancing workflow efficiency in clinical environments.",
            features: [
              "Ergonomic curved backrest for lumbar and upper-body support",
              "Adjustable armrest for precision stability during treatments",
              "Gas-lift height adjustment with smooth pneumatic control",
              "360° swivel function with medical-grade castor wheels for mobility",
              "Premium antimicrobial leather upholstery in soft blue finish",
              "High-density foam seat for all-day comfort and posture alignment",
              "Durable chrome-plated base with integrated foot ring support",
            ],
            industries:
              "Ideal for dental practitioners, orthodontists, cosmetic surgeons, dermatologists, and clinical technicians seeking ergonomic and durable seating solutions.",
          },
          {
            code: "AD-SA04B",
            coverImage: "/images/stools/dental-stools/AD-SA04B/1.webp",
            images: Array.from(
              { length: 2 },
              (_, i) =>
                `/images/stools/dental-stools/AD-SA04B/${i + 1}.webp`
            ),
            intro:
              "A comfortable, height-adjustable dental stool designed for stability, mobility, and long-lasting support during clinical procedures.",
            description:
              "The SKIEN AD-SA04B Dental Stool provides ergonomic seating for practitioners, featuring a cushioned seat and supportive backrest upholstered in durable white material. Its smooth gas-lift system allows quick height adjustment, while the chrome 5-star base ensures stability and effortless movement across treatment rooms. Equipped with two control levers for seat and backrest adjustment, the AD-SA04B offers customizable comfort for extended clinical use. Designed with a clean, modern aesthetic, this stool is ideal for dental, cosmetic, and medical environments that require mobility, comfort, and professional durability.",
            features: [
              "Padded white seat for comfort during long procedures",
              "Supportive cushioned backrest for improved posture",
              "Smooth gas-lift height adjustment",
              "Chrome 5-star base for stability",
              "Easy-rolling caster wheels for unrestricted movement",
              "Dual adjustment levers for seat and backrest positioning",
              "Durable, easy-clean upholstery suited for clinical environments",
              "Lightweight and maneuverable for flexible workspace layout",
            ],
            industries:
              "Ideal for dental clinics, medical practices, cosmetic studios, dermatology rooms, and treatment environments requiring ergonomic practitioner seating.",
          },
          {
            code: "AD-SA04C",
            coverImage: "/images/stools/dental-stools/AD-SA04C/1.webp",
            images: Array.from(
              { length: 2 },
              (_, i) =>
                `/images/stools/dental-stools/AD-SA04C/${i + 1}.webp`
            ),
            intro:
              "A supportive and adjustable dental stool designed for ergonomic comfort, smooth mobility, and reliable daily performance in clinical environments.",
            description:
              "The SKIEN AD-SA04C Dental Stool provides comfortable and stable seating for practitioners, featuring a padded white seat and matching backrest with a contrasting black shell. Its gas-lift mechanism ensures easy height adjustment, while dual control levers allow fine-tuning of both seat height and backrest angle to support proper posture during long procedures. The chrome 5-star base offers excellent stability and effortless movement on caster wheels, making the AD-SA04C a dependable choice for dental, cosmetic, and medical treatment rooms requiring flexibility, comfort, and a clean professional appearance.",
            features: [
              "Comfortable padded white seat for extended use",
              "Ergonomic cushioned backrest with black shell support",
              "Gas-lift system for smooth height adjustment",
              "Dual levers for height and backrest angle control",
              "Chrome 5-star base offering strong stability",
              "Smooth caster wheels for unrestricted mobility",
              "Durable, easy-clean upholstery suited for clinical use",
              "Lightweight and maneuverable for flexible work positioning",
            ],
            industries:
              "Ideal for dental clinics, cosmetic studios, dermatology rooms, medical treatment rooms, and any professional environment requiring ergonomic practitioner seating.",
          },
          {
            code: "AD-SA07",
            coverImage: "/images/stools/dental-stools/AD-SA07/1.webp",
            images: Array.from(
              { length: 1 },
              (_, i) =>
                `/images/stools/dental-stools/AD-SA07/${i + 1}.webp`
            ),
            intro:
              "An ergonomic dental stool designed with a sculpted backrest, smooth mobility, and reliable height adjustment for daily clinical use.",
            description:
              "The SKIEN AD-SA07 Dental Stool features a uniquely contoured backrest that supports natural posture while maintaining freedom of movement during procedures. Its cushioned seat and cream upholstery provide long-lasting comfort, while dual adjustment levers allow practitioners to easily control seat height and backrest positioning. The chrome 5-star base ensures stability, and the smooth-rolling caster wheels offer effortless mobility across treatment rooms. Lightweight, durable, and easy to clean, the AD-SA07 is ideal for professionals who require comfort and flexibility throughout the day.",
            features: [
              "Ergonomic sculpted backrest for enhanced posture support",
              "Soft, cushioned cream seat for extended comfort",
              "Gas-lift height adjustment for flexible positioning",
              "Dual control levers for height and backrest angle",
              "Chrome 5-star base for superior stability",
              "Smooth caster wheels for unrestricted movement",
              "Durable, easy-clean upholstery suited for clinical settings",
              "Lightweight and easy to maneuver between workstations",
            ],
            industries:
              "Ideal for dental clinics, medical practices, cosmetic studios, dermatology rooms, and wellness facilities requiring ergonomic practitioner seating.",
          },
          {
            code: "AD-SA08",
            coverImage: "/images/stools/dental-stools/AD-SA08/1.webp",
            images: Array.from(
              { length: 6 },
              (_, i) =>
                `/images/stools/dental-stools/AD-SA08/${i + 1}.webp`
            ),
            intro:
              "A height-adjustable dental stool with foot ring support, ergonomic backrest, and smooth mobility — designed for elevated clinical work and all-day practitioner comfort.",
            description:
              "The SKIEN AD-SA08 Dental Stool features a supportive white cushioned seat and an ergonomically contoured backrest designed to maintain proper posture during precision work. Its integrated foot ring provides enhanced leg support, making it ideal for elevated seating positions common in dental and aesthetic procedures. Dual adjustment levers allow easy control of both seat height and backrest angle, while the chrome 5-star base ensures exceptional stability. Smooth caster wheels provide effortless movement across treatment spaces, and the durable, easy-clean upholstery makes the AD-SA08 a practical and comfortable choice for busy clinical environments.",
            features: [
              "Ergonomic cushioned backrest with tilt adjustment",
              "Soft padded white seat for extended comfort",
              "Gas-lift height adjustment for flexible positioning",
              "Integrated foot ring for elevated support and stability",
              "Chrome 5-star base for reliable, balanced seating",
              "Smooth caster wheels for enhanced mobility",
              "Dual levers for seat height and backrest angle control",
              "Durable, easy-clean upholstery suited for clinical settings",
            ],
            industries:
              "Ideal for dental clinics, cosmetic studios, dermatology rooms, medical practices, and environments requiring elevated, ergonomic practitioner seating.",
          },
        ],
      },
      {
        name: "Saddle Chairs",
        slug: "saddle-chairs",
        items: [
          {
            code: "AD-S",
            coverImage: "/images/stools/saddle-chairs/AD-S/1.webp",
            images: Array.from(
              { length: 1 },
              (_, i) => `/images/stools/saddle-chairs/AD-S/${i + 1}.webp`
            ),
            intro:
              "A posture-enhancing saddle chair designed to promote spinal alignment, improve comfort, and support mobility for professionals during long working hours.",

            description:
              "The SKIEN AD-S Saddle Chair combines ergonomic design with durable construction to deliver a healthier seating solution for clinics, salons, and workspaces where practitioners remain seated for extended periods. Its contoured saddle-shaped cushion encourages natural spinal curvature, reducing lower-back strain and improving circulation. The gas-lift height adjustment allows effortless positioning, while the heavy-duty chrome base provides excellent balance and 360° rotation. Upholstered in premium antimicrobial leather, the AD-S offers an easy-to-clean, stylish seat that fits seamlessly into medical, dental, or beauty treatment settings.",

            features: [
              "Ergonomic saddle-style seat promotes natural posture and core engagement",
              "High-density foam cushioning for comfort and long-term support",
              "Gas-lift height adjustment for customized seating levels",
              "360° swivel functionality with smooth-rolling caster wheels",
              "Premium antimicrobial leather upholstery for hygiene and easy cleaning",
              "Reinforced chrome base for superior stability and mobility",
              "Compact, space-efficient design suitable for clinics and spas",
            ],

            industries:
              "Ideal for dentists, beauty therapists, aestheticians, physiotherapists, and wellness professionals seeking posture-supportive, mobile seating.",
          },
          {
            code: "AD-SA04",
            coverImage: "/images/stools/saddle-chairs/AD-SA04/1.webp",
            images: Array.from(
              { length: 12 },
              (_, i) =>
                `/images/stools/saddle-chairs/AD-SA04/${i + 1}.webp`
            ),
            intro:
              "An ergonomic saddle chair designed to promote healthy posture, reduce lower-back strain, and support practitioners during long procedures.",
            description:
              "The SKIEN AD-SA04 Saddle Chair combines ergonomic seating with full adjustability, featuring a contoured saddle seat and supportive backrest upholstered in premium blue cushioning. Its dual adjustment levers allow precise control of seat height and seat tilt, helping practitioners maintain a neutral spine posture during extended treatments. The backrest height and angle can also be adjusted for personalized support. A sturdy chrome 5-star base and smooth-rolling caster wheels ensure stability and effortless mobility across clinical spaces. Ideal for professionals who require comfort, mobility, and proper postural alignment, the AD-SA04 provides reliable performance in busy treatment environments.",
            features: [
              "Ergonomic saddle seat for improved posture and reduced back strain",
              "Padded blue seat and backrest for enhanced comfort",
              "Gas-lift height adjustment for flexible seating",
              "Dual control levers for seat height and seat tilt",
              "Adjustable backrest height and angle",
              "Chrome 5-star base for strong stability",
              "Smooth caster wheels for easy mobility",
              "Durable upholstery designed for clinical environments",
            ],
            industries:
              "Ideal for dental clinics, medical practices, physiotherapy spaces, cosmetic studios, and any professional setting requiring ergonomic practitioner seating.",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    icon: icon5,
    simage: "",
    title: "Autoclaves",
    slug: "autoclaves",
    catalog: "",
    shortDesc:
      "Reliable sterilization units ensuring hygiene and safety in clinics, spas, and salons.",
    subcategories: [
      {
        name: "Autoclaves",
        slug: "autoclaves",
        items: [
          {
            code: "HS10",
            coverImage: "/images/autoclaves/autoclave/AD-HS10/1.webp",
            images: Array.from(
              { length: 3 },
              (_, i) =>
                `/images/autoclaves/autoclave/AD-HS10/${i + 1}.webp`
            ),
            manual:
              "/files/manuals/autoclaves/hs-10/hs-10-user-manual.pdf",
            intro:
              "A high-performance steam sterilizer engineered for precision, safety, and ease of use in medical, dental, and laboratory environments.",
            description:
              "The SKIEN HS10 18L Autoclave delivers advanced sterilization performance with a durable stainless-steel chamber and intelligent temperature control system. Designed for consistent operation and rapid cycles, it ensures complete elimination of bacteria, spores, and viruses across medical instruments and equipment. Its compact form makes it ideal for clinics with limited workspace, while the integrated safety lock and automatic pressure release enhance user protection. With a modern digital control panel and efficient water recycling design, the HS10 combines convenience, reliability, and sustainability in one robust unit.",
            features: [
              "18-litre durable stainless-steel sterilization chamber for longevity and hygiene",
              "Automatic temperature and pressure regulation for precise control",
              "Built-in safety interlock and pressure release mechanism",
              "Digital display with cycle monitoring and programmable modes",
              "Compact and portable design ideal for clinics and laboratories",
              "Energy-efficient water recycling and low-noise operation",
              "Compliant with international sterilization safety standards",
            ],
            industries:
              "Ideal for dental practices, medical clinics, tattoo studios, laboratories, and aesthetic centers requiring efficient instrument sterilization.",
          },
          {
            code: "Aries 23",
            coverImage: "/images/autoclaves/autoclave/aries-23/1.webp",
            images: Array.from(
              { length: 3 },
              (_, i) =>
                `/images/autoclaves/autoclave/aries-23/${i + 1}.webp`
            ),
            catalog: "/files/catalog/autoclaves/aries/aries-catalog.pdf",
            intro:
              "Reliable, efficient, and compact, the SKIEN Aries 23 Autoclave delivers hospital-grade sterilization in a sleek benchtop unit designed for busy clinics and treatment facilities.",
            description:
              "The Aries 23L Autoclave is built to meet the highest standards of infection control. Equipped with intelligent microprocessor control, it automatically regulates temperature, pressure, and sterilization time to achieve consistent results. The large 23-litre chamber accommodates multiple instruments or larger sets, while the built-in digital display allows real-time monitoring of every cycle.",
            features: [
              "23-litre stainless steel chamber with durable, corrosion-resistant construction",
              "Fully automatic operation with pre-set and customizable sterilization programs",
              "High-resolution digital touch display for real-time cycle data and diagnostics",
              "Efficient drying system ensuring instruments are ready for immediate use",
              "Water tank with easy top-loading access and drain system",
              "Advanced safety features including pressure and temperature protection",
              "Fast heat-up and cycle times to optimize daily workflow",
              "Quiet, low-maintenance design ideal for clinics",
            ],
            industries:
              "Ideal for dental practices, medical clinics, tattoo studios, laboratories, and aesthetic centers requiring efficient instrument sterilization.",
          },
        ],
      },
      {
        name: "UV Sterilizers",
        slug: "uv-sterilizers",
        items: [
          {
            code: "AD-HS12B",
            coverImage: "/images/autoclaves/uv-cabinet/11.webp",
            images: Array.from(
              { length: 20 },
              (_, i) => `/images/autoclaves/uv-cabinet/${i + 1}.webp`
            ),
            intro:
              "A professional UV sterilization cabinet that provides efficient, chemical-free disinfection for medical, dental, and beauty instruments.",
            description:
              "The SKIEN UV Cabinet ensures effective sterilization through high-intensity ultraviolet (UV-C) light, eliminating bacteria, viruses, and contaminants from reusable tools and instruments. Designed with a stainless-steel reflective interior, it maximizes light distribution for uniform exposure. Its double-layered tempered glass door offers visibility while preventing UV leakage, and the integrated safety switch automatically disables UV emission when the door is opened. The UV-01 operates quietly and efficiently, making it an ideal hygiene companion for clinics, salons, and wellness centers. Durable, compact, and easy to clean, this cabinet delivers dependable sterilization with minimal maintenance.",
            features: [
              "UV-C disinfection technology eliminates bacteria and viruses without chemicals",
              "Durable stainless-steel interior with reflective surfaces for even light exposure",
              "Tempered glass door with secure magnetic seal and safety switch",
              "Automatic power-off function when door is opened",
              "Spacious multi-tray design for holding various instruments",
              "Compact, modern housing ideal for countertops or workstations",
              "Low energy consumption and silent operation",
            ],
            industries:
              "Ideal for medical clinics, dental practices, spas, and tattoo studios requiring safe and efficient instrument sterilization.",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    icon: icon4,
    simage: "",
    title: "Lights",
    slug: "examination-lights",
    catalog: "/files/catalog/skien-product-catalog.pdf",
    shortDesc:
      "High-quality examination lights providing clarity and precision for medical and beauty treatments.",
    subcategories: [
      {
        name: "Examination Lights",
        slug: "examination-lights",
        items: [
          {
            code: "KD-2003W-3",
            coverImage: "/images/examination-lights/KD-2003W-3/1.webp",
            images: Array.from(
              { length: 4 },
              (_, i) =>
                `/images/examination-lights/KD-2003W-3/${i + 1}.webp`
            ),
            intro:
              "A compact, flexible LED examination light engineered for precision illumination and ergonomic performance in medical and aesthetic procedures.",
            description:
              "The SKIEN KD-2003W-3 Examination Light delivers high-intensity, shadow-free illumination for detailed examinations and treatments. Designed with a flexible gooseneck arm, it allows effortless positioning and directional accuracy, ensuring optimal visibility in any clinical setup. The energy-efficient LED head produces cool, white light with minimal heat emission, protecting both practitioner and patient comfort. Its versatile mounting options — including wall, table-clamp, and mobile stand — provide adaptable use across various professional environments. Built from durable materials and featuring a sleek, low-profile design, the KD-2003W-3 combines performance, precision, and reliability in one modern unit.",
            features: [
              "High-intensity LED lighting with superior color accuracy",
              "Flexible gooseneck arm for precise and stable positioning",
              "Cool-white light output with minimal heat radiation",
              "Multiple mounting options: wall mount, table clamp, or mobile stand",
              "Durable metal housing with compact control unit and power indicator",
              "Energy-efficient design with long-life LED performance",
              "Silent operation ideal for examination and treatment rooms",
            ],
            industries:
              "Ideal for hospitals, dental practices, medical clinics, and aesthetic centers requiring adjustable, high-clarity illumination.",
          },
          {
            code: "KD-2009W-1",
            coverImage: "/images/examination-lights/KD-2009W-1/1.webp",
            images: Array.from(
              { length: 11 },
              (_, i) =>
                `/images/examination-lights/KD-2009W-1/${i + 1}.webp`
            ),
            intro:
              "A versatile LED examination light providing bright, focused illumination and flexible mounting options for clinical precision.",
            description:
              "The SKIEN KD-2009W-1 Examination Light combines powerful illumination with ergonomic versatility, making it ideal for clinics, hospitals, and treatment rooms. Its cool white LED technology offers high brightness and consistent color rendering, ensuring detailed visual clarity during procedures. The adjustable gooseneck arm allows effortless light positioning, while multiple mounting configurations — including wall, table, and mobile stand — make it adaptable to any workspace. The energy-efficient design minimizes heat output and operating costs, delivering reliable, shadow-free performance across medical and aesthetic applications.",
            features: [
              "High-intensity LED light source for clear, shadow-free illumination",
              "Flexible gooseneck arm for adjustable light direction and focus",
              "Multiple mounting options: wall mount, table clamp, or mobile stand",
              "Cool white LED with excellent color rendering for visual accuracy",
              "Energy-efficient operation with minimal heat emission",
              "Durable construction with smooth, cleanable surfaces",
              "Compact control box with brightness adjustment dial",
            ],
            industries:
              "Ideal for hospitals, dermatology and dental clinics, medical examination rooms, and beauty treatment facilities requiring precise, adjustable lighting.",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    icon: icon6,
    simage: "",
    title: "Medical Trolleys",
    slug: "medical-trolleys",
    catalog: "/files/catalog/skien-product-catalog.pdf",
    shortDesc:
      "Durable, mobile trolleys designed to organize and support equipment in treatment spaces.",
    subcategories: [
      {
        name: "Medical Trolleys",
        slug: "medical-trolleys",
        items: [
          {
            code: "AD-BE01",
            coverImage: "/images/medical-trolleys/AD-BE01/1.webp",
            images: Array.from(
              { length: 8 },
              (_, i) => `/images/medical-trolleys/AD-BE01/${i + 1}.webp`
            ),
            intro:
              "A compact, flexible LED examination light engineered for precision illumination and ergonomic performance in medical and aesthetic procedures.",
            description:
              "The SKIEN KD-2003W-3 Examination Light delivers high-intensity, shadow-free illumination for detailed examinations and treatments. Designed with a flexible gooseneck arm, it allows effortless positioning and directional accuracy, ensuring optimal visibility in any clinical setup. The energy-efficient LED head produces cool, white light with minimal heat emission, protecting both practitioner and patient comfort. Its versatile mounting options — including wall, table-clamp, and mobile stand — provide adaptable use across various professional environments. Built from durable materials and featuring a sleek, low-profile design, the KD-2003W-3 combines performance, precision, and reliability in one modern unit.",
            features: [
              "High-intensity LED lighting with superior color accuracy",
              "Flexible gooseneck arm for precise and stable positioning",
              "Cool-white light output with minimal heat radiation",
              "Multiple mounting options: wall mount, table clamp, or mobile stand",
              "Durable metal housing with compact control unit and power indicator",
              "Energy-efficient design with long-life LED performance",
              "Silent operation ideal for examination and treatment rooms",
            ],
            industries:
              "Ideal for hospitals, dental practices, medical clinics, and aesthetic centers requiring adjustable, high-clarity illumination.",
          },
          {
            code: "AD-BE02",
            coverImage: "/images/medical-trolleys/AD-BE02/1.webp",
            images: Array.from(
              { length: 15 },
              (_, i) => `/images/medical-trolleys/AD-BE02/${i + 1}.webp`
            ),
            intro:
              "A premium mobile medical trolley with elevated glass shelving, integrated power access, and a mounted magnifying lamp — engineered for clean, organized, and efficient clinical work.",
            description:
              "The SKIEN AD-BE02 Medical Trolley offers a fully equipped workstation designed for modern treatment rooms, combining four smooth-glide storage drawers with a raised frosted glass top shelf for device placement and easy cleaning. The trolley features a mounted LED magnifying lamp with an adjustable arm, ideal for detailed procedures and examinations. A built-in multi-socket power panel and main power switch provide reliable access for clinical equipment, while durable caster wheels ensure effortless mobility across the workspace. With its sleek white finish and elevated glass platform supported by metal posts, the AD-BE02 delivers a professional, organized, and versatile solution for busy clinics.",
            features: [
              "Four pull-out drawers for organized storage",
              "Raised frosted glass top shelf supported by metal posts",
              "Mounted LED magnifying lamp with adjustable arm",
              "Integrated multi-socket power panel for clinical devices",
              "Main power switch and AC input port",
              "Smooth caster wheels for easy movement",
              "Clean, durable medical-grade white finish",
              "Stable construction suitable for daily professional use",
              "Easy-clean glass and metal surfaces",
            ],
            industries:
              "Perfect for medical clinics, dermatology practices, aesthetic studios, beauty salons, physiotherapy rooms, and any treatment environment requiring organized mobile storage and integrated lighting.",
          },
          {
            code: "SC-23-02",
            coverImage: "/images/medical-trolleys/SC-23-02/1.webp",
            images: Array.from(
              { length: 10 },
              (_, i) => `/images/medical-trolleys/SC-23-02/${i + 1}.webp`
            ),
            intro:
              "A versatile, multi-compartment medical trolley designed for organized storage, smooth mobility, and clean workflow management in professional treatment spaces.",
            description:
              "The SKIEN SC-23-02 Medical Trolley is a high-capacity storage unit built for clinics and treatment rooms that require efficient organization and quick accessibility. It features a wide top tray with raised spill-protective edges and integrated side handles, making it ideal for holding instruments, consumables, or devices. The trolley includes multiple storage options: a large upper drawer, two mid-sized pull-out drawers, a spacious bottom drawer, and a hinged side cabinet for bulk items. A long side extension drawer provides additional working space when needed. The unit is equipped with a built-in multi-socket power panel and main power switch, allowing clinicians to connect equipment directly at the workstation. Mounted on smooth caster wheels, the SC-23-02 ensures effortless movement and reliable stability, delivering a practical, durable, and clean-lined solution for busy medical and aesthetic environments.",
            features: [
              "Large top tray with spill-guard edges and integrated carrying handles",
              "Multiple storage compartments including cabinet + 3 drawers",
              "Full-length side extension drawer for additional workspace",
              "Built-in power panel with universal sockets",
              "Main power switch and AC input port",
              "Smooth-rolling caster wheels for easy mobility",
              "Durable medical-grade white finish",
              "Spacious internal cabinet with hinged door",
              "Ergonomic chrome handles across all drawers",
            ],
            industries:
              "Ideal for medical clinics, dermatology centers, beauty therapy rooms, IV therapy suites, aesthetic studios, and any professional setting requiring organized, mobile storage.",
          },
          {
            code: "SCY015",
            coverImage: "/images/medical-trolleys/SCY015/1.webp",
            images: Array.from(
              { length: 14 },
              (_, i) => `/images/medical-trolleys/SCY015/${i + 1}.webp`
            ),
            intro:
              "A modern stainless-steel medical trolley with multi-level storage, integrated power access, and smooth mobility—engineered for efficient, organized clinical workflow.",
            description:
              "The SKIEN SCY015 Medical Trolley combines durable stainless-steel construction with a practical multi-tier layout designed to support daily clinical operations. Its Z-frame structure offers two spacious trays with raised edges to prevent item slippage, along with two pull-out drawers for organized instrument storage. One drawer includes a molded compartment tray for neatly separating consumables and smaller tools. The integrated power panel with dual sockets and a main switch allows clinicians to connect devices directly at the trolley, enhancing workflow efficiency. Heavy-duty drawer sliders ensure smooth opening, while caster wheels provide effortless mobility across treatment rooms. With its modern metallic finish and ergonomic handles, the SCY015 is a stylish, functional, and highly durable solution for clinics and aesthetic environments.",
            features: [
              "Durable stainless-steel body with a modern brushed finish",
              "Two upper trays with raised spill-prevention edges",
              "Two pull-out drawers including one with a compartment organizer",
              "Heavy-duty drawer sliders for smooth operation",
              "Integrated dual-socket power panel with main switch",
              "Stable Z-frame design for improved accessibility",
              "Lower shelf for additional storage capacity",
              "Ergonomic chrome handles on drawers",
              "Caster wheels for easy mobility",
            ],
            industries:
              "Ideal for aesthetic clinics, dermatology practices, medical treatment rooms, dental practices, spa environments, and any professional workspace requiring mobile organized storage with power integration.",
          },
          {
            code: "TC-10-04",
            coverImage: "/images/medical-trolleys/TC-10-04/1.webp",
            images: Array.from(
              { length: 4 },
              (_, i) => `/images/medical-trolleys/TC-10-04/${i + 1}.webp`
            ),
            intro:
              "A compact, modern medical trolley with integrated power outlets and multi-level shelving—perfect for supporting devices and equipment in treatment spaces.",
            description:
              "The SKIEN TC-10-04 Medical Trolley is a sleek and functional equipment stand designed to keep clinical tools powered, organized, and within reach. Its angled Z-frame structure supports two durable metal shelves with raised edges to prevent items from slipping. The trolley features three built-in universal power sockets and a main power input, making it ideal for powering devices such as facial machines, magnifying lamps, and diagnostic tools. A sturdy top handle ensures easy maneuverability, while the smooth-rolling caster wheels allow seamless movement across treatment rooms. With its clean white finish, stable base, and integrated power management, the TC-10-04 offers a reliable, space-efficient solution for modern clinical and aesthetic environments.",
            features: [
              "Two metal shelves with raised protective edges",
              "Three integrated universal power sockets",
              "Main power input port for safe electrical connection",
              "Angled Z-frame design for stability and easy access",
              "Top carrying handle for convenient movement",
              "Smooth caster wheels for effortless mobility",
              "Sturdy metal construction with clean white finish",
              "Ideal for supporting electronic devices and treatment equipment",
            ],
            industries:
              "Suitable for aesthetic clinics, dermatology practices, physiotherapy rooms, salons, medical treatment rooms, and any workspace needing powered device support.",
          },
          {
            code: "TC25-01",
            coverImage: "/images/medical-trolleys/TC25-01/1.webp",
            images: Array.from(
              { length: 7 },
              (_, i) => `/images/medical-trolleys/TC25-01/${i + 1}.webp`
            ),
            intro:
              "A sturdy, modern medical trolley with a minimalist Z-frame design, smooth-glide storage drawer, and multi-level shelving—perfect for organizing tools and supporting equipment in clinical and aesthetic environments.",
            description:
              "The SKIEN TC25-01 Medical Trolley is a sleek, durable equipment stand built for professional treatment spaces that require both mobility and efficient organization. Its angled Z-frame offers enhanced structural stability, while the spacious top platform and lower shelf provide ample room for devices, consumables, and daily-use tools. The integrated drawer slides smoothly on high-quality rails, keeping smaller items neatly stored and easily accessible. Medical-grade caster wheels ensure silent, controlled movement throughout the workspace. With its clean white finish, ergonomic handle, and easy-clean surfaces, the TC25-01 delivers a reliable, space-saving solution for clinics, salons, and medical rooms seeking both style and practicality.",
            features: [
              "Smooth-glide storage drawer for tools and consumables",
              "Two spacious shelves for devices and daily-use equipment",
              "Medical-grade caster wheels with secure locking brakes",
              "Durable Z-frame design for superior stability",
              "Easy-clean powder-coated metal construction",
              "Ergonomic front handle for effortless maneuvering",
              "Raised top edges to prevent items from slipping",
              "Ideal layout for compact treatment rooms",
            ],
            industries:
              "Suitable for aesthetic clinics, dermatology practices, dental rooms, physiotherapy centres, beauty salons, medical consulting rooms, and any environment needing organized equipment support.",
          },
          {
            code: "TC25-02",
            coverImage: "/images/medical-trolleys/TC25-02/1.webp",
            images: Array.from(
              { length: 7 },
              (_, i) => `/images/medical-trolleys/TC25-02/${i + 1}.webp`
            ),
            intro:
              "A minimalist, open-frame medical trolley designed for easy access, smooth mobility, and efficient organization of daily-use equipment.",
            description:
              "The SKIEN TC25-02 Medical Trolley is a compact, lightweight equipment stand built for treatment spaces that require simplicity, durability, and fast accessibility. Its clean Z-frame structure supports two open metal shelves with raised edges, providing stable storage for devices, consumables, and tools. The wide top platform is ideal for frequently used equipment, while the centre shelf offers quick-reach convenience during procedures. Medical-grade caster wheels ensure silent, smooth movement across clinical floors, and the powder-coated metal construction makes cleaning effortless. With its modern profile and practical layout, the TC25-02 is a reliable, space-saving solution for busy clinical and aesthetic environments.",
            features: [
              "Two open metal shelves with raised safety edges",
              "Spacious top platform for essential devices",
              "Stable Z-frame design for durability and accessibility",
              "Medical-grade caster wheels with smooth, quiet rolling",
              "Compact footprint ideal for small treatment rooms",
              "Open-shelf layout for quick access to tools and products",
            ],
            industries:
              "Ideal for aesthetic clinics, dermatology rooms, massage studios, physiotherapy centres, beauty salons, dental rooms, and general medical treatment spaces requiring simple, fast-access equipment support.",
          },
          {
            code: "Y001A",
            coverImage: "/images/medical-trolleys/Y001A/1.webp",
            images: Array.from(
              { length: 6 },
              (_, i) => `/images/medical-trolleys/Y001A/${i + 1}.webp`
            ),
            intro:
              "A spacious, multi-drawer medical trolley designed for professionals who need organized, secure, and easily accessible storage for clinical tools and consumables.",

            description:
              "The SKIEN Y001A Medical Trolley is a premium, high-capacity storage system built for clinics that require efficient organization and quick access to instruments. It features multiple smooth-gliding drawers—including a lockable top drawer with removable compartment trays—ideal for sorting small tools, accessories, and consumables. The tempered glass top shelf provides a durable, easy-to-clean working surface while adding a sleek, modern aesthetic. The trolley moves effortlessly on its swivel caster wheels, making it suitable for fast-paced environments. With its combination of secure storage, segmented organization, and durable construction, the Y001A is ideal for maintaining a clean and efficient workspace in medical and aesthetic settings.",

            features: [
              "Multi-drawer storage system for maximum organization",
              "Lockable top drawer for secure storage of small tools or valuables",
              "Removable compartment tray for detailed internal organization",
              "Tempered glass top surface for durability and easy cleaning",
              "Smooth heavy-duty drawer sliders for effortless operation",
              "Sturdy metal construction for long-term reliability",
              "Swivel caster wheels for easy movement around treatment spaces",
              "Spacious lower drawers for larger devices, equipment, or consumables",
            ],

            industries:
              "Ideal for dental practices, aesthetic clinics, salons, dermatology rooms, medical treatment facilities, and any environment requiring organized, secure tool storage.",
          },
          {
            code: "YCM3",
            coverImage: "/images/medical-trolleys/YCM3/1.webp",
            images: Array.from(
              { length: 6 },
              (_, i) => `/images/medical-trolleys/YCM3/${i + 1}.webp`
            ),
            intro:
              "A sleek multi-drawer medical trolley designed for efficient storage, smooth mobility, and secure organization of clinical tools and consumables.",

            description:
              "The SKIEN YCM3 Medical Trolley is a modern, space-efficient storage unit built for clinics that require tidy, organized, and secure access to instruments. It features multiple smooth-glide drawers, including a lockable top drawer equipped with a removable, multi-section compartment tray—ideal for organizing small tools, accessories, and treatment items. The remaining drawers offer generous open storage for larger equipment or consumables. A durable, easy-clean top surface provides additional workspace, while heavy-duty casters ensure effortless movement between rooms. With its minimalist design, secure locking function, and flexible drawer layout, the YCM3 is an excellent choice for maintaining a clean, professional workflow in medical and aesthetic environments.",

            features: [
              "Multi-drawer storage system for organized tool management",
              "Lockable top drawer for secure storage",
              "Removable sectioned tray for small tools and accessories",
              "Smooth heavy-duty drawer slides for easy access",
              "Large lower drawers for bulk storage",
              "Durable, easy-clean top surface",
              "Stable construction with smooth caster wheels",
              "Minimalist, modern design for professional treatment spaces",
            ],

            industries:
              "Suitable for dental clinics, aesthetic and beauty salons, dermatology rooms, physiotherapy centers, medical examination rooms, and any professional environment requiring organized equipment storage.",
          },
        ],
      },
    ],
  },
];
export default Products;
